export const MENU_ID_JSM_SETTINGS = 'project/service-desk/settings';
